
<div class="modal-header border-0 pb-0 pt-1">
  <h4 class="modal-title text-left f-bold-dubai pb-3 pull-left">{{model?.subjectAtd}} </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal('')">
    <span aria-hidden="true"><i class="la la-close"></i></span>
  </button>
</div>
<div class="px-3">

  <span class="pr-2">
    <a *ngIf="model.approvalStatus =='Draft'" class="text-secondary">{{model.approvalStatus}}</a>
    <a class="text-warning" *ngIf="model.approvalStatus =='Under Review' || model.approvalStatus =='Reviewed'">{{model.approvalStatusView}}</a>
    <a class="text-primary" *ngIf="model.approvalStatus =='Approved'|| model.approvalStatus == 'Pending Approval'">{{model.approvalStatusView}}</a>
    <a class="text-success" *ngIf="model.approvalStatus =='Published'">{{model.approvalStatus}}</a>
  </span> | <span class="px-2"><a (click)="onChangemomTab('general')"  class="text-muted">{{getMainActionPoints().length}} Action Points</a></span> | <span class="px-2"><a (click)="onChangemomTab('files')" class="text-muted">{{fileList.length}} Files</a></span>
</div>

<div class="custom-tab position-relative border-bottom">
  <div class="position-absolute absolute-pos-btn d-sm-block res-view-btn">

    <a class="btn btn-sm btn-outline-secondary text-secondary f-bold-dubai px-4 bg-white" *ngIf="(model.enteredBy == loginUserId || model.isReviewer || model.isApprover || isEditAccess)" (click)="onChangeEdit()">{{text}}</a>
    
    <a class="btn btn-sm btn-success text-white mx-1 f-bold-dubai px-3" (click)="downloadPDFMeeting()">Download</a>
    <!-- <a class="btn btn-sm btn-success text-white mx-1 f-bold-dubai px-3" (click)="DownloadAttachment(model?.subjectAtd)">Generate</a> -->
    <a class="btn btn-sm btn-success text-white mx-1 f-bold-dubai px-3" (click)="openApproveModal(templateApprove)" *ngIf="model.published == 4 && model.isApprover">Approve </a>
    <a class="btn btn-sm btn-success text-white mx-1 f-bold-dubai px-3" (click)="openRevModal(templateRev)" *ngIf="model.published == 2 && model.isReviewer">Review</a>
    <a class="btn btn-sm btn-success text-white mx-1 f-bold-dubai px-3" (click)="openReviewModal(templateReview)" *ngIf="model.published == 0 && model.enteredBy == loginUserId && !model.workFlowCondition1">Send for Review</a>
    <a class="btn btn-sm btn-success text-white mx-1 f-bold-dubai px-3" (click)="openApprovalModal(templateApproval)" *ngIf="model.published == 3 &&  model.enteredBy == loginUserId">Send for Approval </a>
    <a class="btn btn-sm btn-success text-white f-bold-dubai px-3" *ngIf="enablePublish()" (click)="openPubModal(templatePublish)">Publish</a>
  </div>
  <ul class="nav bar_tabs bg-white" id="momTab" role="tablist">
    <li class="nav-item"><a class="nav-link" id="general-tab" (click)="onChangemomTab('general')" [ngClass]="{ 'active':momTab1}"  data-toggle="tab" href="#general" role="tab" aria-controls="general" aria-selected="true">General</a></li>
    <li class="nav-item"><a class="nav-link" id="chat-tab" (click)="onChangemomTab('chat')" [ngClass]="{ 'active':momTab2}" data-toggle="tab" href="#chat" role="tab" aria-controls="chat" aria-selected="false">Chat</a></li>
    <li class="nav-item"><a class="nav-link" id="files-tab" (click)="onChangemomTab('files')" [ngClass]="{ 'active':momTab3}" data-toggle="tab" href="#files" role="tab" aria-controls="files" aria-selected="false">Files</a></li>
  </ul>
</div>
<div class="modal-body p-0 bg-light editcancel">
  <div class="x_content custom-tab">
    <div class="x_content custom-tab">
      <div class="tab-content px-3" id="momContentmom">
        <div class="tab-pane fade" [ngClass]="{ 'active show':momTab1}" id="general" role="tabpanel" aria-labelledby="general-tab">
          <div class="col-lg-12 px-0">
            <div id="accordion" class="accordion-section">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h5 class="mb-0">
                    <a class="btn btn-link text-secondary" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Meeting Details
                    </a>
                  </h5>
                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                  <div class="card-body meetingdetails pt-2">
                    <div class="clearfix" *ngIf="viewSelected">
                      <div class="row">

                        <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\notes.jpg" /> {{model?.subjectAtd}}</div>
                        <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\meeting.jpg" /> {{model?.meetingName}}</div>
                        <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\date.jpg" /> <span class="d-day"> {{model?.fMeetingDateAtd |  date:'MMM'}}</span>   {{model.fMeetingDateAtd |  date:'dd/MM/yyyy'}}  <span class="d-time"> {{model.startTimeAtd | timeFormat}} - {{model.endTimeAtd | timeFormat}}</span></div>
                        <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\location.jpg" /> {{model.meetingRoomName !=''?model.meetingRoomName:'NA'}}</div>
                        <div class="col-md-6 py-2"><img class="img-fluid" src="\assets\v2\img\location.jpg" /> {{model.locationName !=''?model.locationName:'NA'}}</div>
                      </div>
                    </div>
                    <div class=" clearfix" *ngIf="editSelected">
                      <div class="row">

                        <div class="col-md-8 border-right pt-3">
                          <form name="gf" id="gf" #gf="ngForm" novalidate>


                            <div class="form-group">
                              <label for="Subject">Subject<span class="text-danger">*</span></label>
                              <input type="email" class="form-control" aria-describedby="Subject" placeholder="Enter the subject for this meeting" id="subject" name="subject"
                                     [ngClass]="{ 'error': isSubmit && subject.invalid }"
                                     [(ngModel)]="model.subjectAtd" required #subject="ngModel">
                              <div *ngIf="isSubmit && subject.invalid">
                                <div class="text-danger">Subject is required</div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                  <label for="meetingData">Date<span class="text-danger">*</span></label>
                                  <input type="date" onkeydown="return false" class="form-control" [(ngModel)]="model.fMeetingDateAtd" required #meetingDate="ngModel" id="meetingDate" name="meetingDate" aria-describedby="date" [ngClass]="{ 'error': isSubmit && meetingDate.invalid }" min="2000-01-02" [max]="today" placeholder="Select date">
                                  <div *ngIf="isSubmit && meetingDate.invalid">
                                    <div class="text-danger"> Date is required</div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                  <label for="Subject">Location<span class="text-danger">*</span></label>
                                  <ng-select [items]="locationdaList" class="form-control p-0"
                                             bindLabel="locationName"
                                             required #locationName="ngModel"
                                             [(ngModel)]="model.locationUno"
                                             id="locationName"
                                             name="locationName"
                                             [ngClass]="{ 'error': isSubmit && locationName.invalid }"
                                             bindValue="locationUno"
                                             [searchable]="true"
                                             [virtualScroll]="true"
                                             [minTermLength]="1"
                                             [multiple]="false"
                                             placeholder="Location">
                                  </ng-select>
                                  <div *ngIf="isSubmit && locationName.invalid">
                                    <div class="text-danger"> Location is required</div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-6" *ngIf="isOthers">
                                <div class="form-group">
                                  <label for="Subject">Others</label>
                                  <input type="text" class="form-control" aria-describedby="date" placeholder="Others" [(ngModel)]="model.others" id="others" name="others">
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                  <label for="Subject">Start Time<span class="text-danger">*</span></label>
                                  <input type="time" class="form-control" aria-describedby="date" placeholder="Start Time" [(ngModel)]="model.fStartTimeAtd" required #startTime="ngModel" (change)="addOneHour()" id="startTime" name="startTime" [ngClass]="{ 'error': isSubmit && startTime.invalid }">
                                  <div *ngIf="isSubmit && startTime.invalid">
                                    <div class="text-danger"> Start Time is required</div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                  <label for="Subject">End Time<span class="text-danger">*</span></label>
                                  <input type="time" class="form-control" aria-describedby="date" placeholder="End Time" [(ngModel)]="model.fEndTimeAtd" required #endTime="ngModel" id="endTime" name="endTime" [ngClass]="{ 'error': isSubmit && endTime.invalid }">
                                  <div *ngIf="isSubmit && endTime.invalid">
                                    <div class="text-danger"> End Time is required</div>
                                  </div>
                                  <div *ngIf="getErrorStatus()"
                                       class="text-danger">
                                    <div><small>End time must be greater than start time</small></div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                  <label for="Subject">Meeting Type<span class="text-danger">*</span></label>
                                  <ng-select [items]="meetingTypeList" class="form-control p-0"
                                             bindLabel="meetingName"
                                             bindValue="meetingTypeUno"
                                             required #meetingType="ngModel"
                                             [(ngModel)]="model.meetingTypeUno"
                                             id="meetingType"
                                             name="meetingType"
                                             [ngClass]="{ 'error': isSubmit && meetingType.invalid }"
                                             [multiple]="false"
                                             [searchable]="true"
                                             [virtualScroll]="true"
                                             [minTermLength]="1"
                                             placeholder="Meeting Type">
                                  </ng-select>
                                  <div *ngIf="isSubmit && meetingType.invalid">
                                    <div class="text-danger"> Meeting Type is required</div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 col-sm-6">
                                <div class="form-group">
                                  <label for="Subject">Meeting Room</label>

                                  <input list="meetingRoomNameId" #meetingRoomName="ngModel" class="form-control"
                                         [(ngModel)]="model.meetingRoomName"
                                         placeholder="Meeting Room"
                                         id="meetingRoomName"
                                         name="meetingRoomName">
                                  <datalist id="meetingRoomNameId">
                                    <option *ngFor="let item of meetingRoomList" [value]="item.meetingRoomName">{{item.meetingRoomName}}</option>
                                  </datalist>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" [value]="model.impCheck" #impCheck="ngModel"
                                         [(ngModel)]="model.impCheck"
                                         id="impCheck"
                                         name="impCheck">
                                  <label class="form-check-label" for="impCheck">
                                    Mark as Important
                                  </label>
                                </div>
                              </div>

                              <div class="col-md-6">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" [value]="model.delegateCheck" #delegateCheck="ngModel"
                                         [(ngModel)]="model.delegateCheck"
                                         id="delegateCheck"
                                         name="delegateCheck">
                                  <label class="form-check-label" for="delegateCheck">
                                    Marked As Confidential
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <button type="button" class="btn btn-outline-secondary pull-right f-bold-dubai px-4" (click)="onSubmitGeneral(gf)">Save </button>
                            </div>
                          </form>
                        </div>

                        <div class="col-md-4 py-3">
                          <h4>Tracking</h4>
                          <div class="list-bullet">
                            <ul class="list-group my-3 mx-2">
                              <li [ngClass]="model.published==1?'active':''" *ngIf="model.published==1 ">
                                Published<br>
                                <small class="text-muted"></small>
                              </li>
                              <!--<li [ngClass]="model.published==5?'active':''" *ngIf="model.published==1 || model.published>4 ">
                                Approved<br>
                                <small class="text-muted"></small>
                              </li>-->
                              <li *ngIf="approver!=null && approver.signImage!=''&& approver.signImage!=null">
                                Approved: {{approver.nameAtd}}<br />
                                <small *ngIf="approver!=null && approver.signImage!=''&& approver.signImage!=null" class="text-muted"> {{approver.modifiedOn |  date:'dd/MM/yyyy hh:mm a'}}</small>

                              </li>
                              <li [ngClass]="model.published==4?'active':''" *ngIf="model.published==4 ">

                                <small class="text-muted text-info position-relative position-top-minus-5">Pending for Approval: {{approver.nameAtd}} </small>
                              </li>
                              <li [ngClass]="model.published==3?'active':''" *ngIf="model.published==3 ">
                                Reviewed and Waiting for Approval Request<br>
                                <small class="text-muted"></small>
                              </li>
                              <li *ngFor="let item of reviewerList; let i = index ">
                                <span *ngIf="model.published==1|| model.published>1">


                                  <!--<span class="text text-dark">{{i+1}} . {{item.nameAtd}}</span><br />-->
                                  <span *ngIf="item.signImage!=''&& item.signImage!=null">
                                    Reviewed: {{item.nameAtd}}<br>
                                    <small *ngIf=" item.signImage!=''&& item.signImage!=null" class="text-muted">  {{item.modifiedOn |  date:'dd/MM/yyyy hh:mm a'}}</small>
                                  </span>
                                  <small *ngIf=" item.signImage==''|| item.signImage==null" class="text-muted text-warning position-relative position-top-minus-5">Pending for Review : {{item.nameAtd}}</small>
                                </span>
                                <span *ngIf="model.published==0 && item.role == 'Reviewer'">

                                  <small *ngIf=" item.signImage==''|| item.signImage==null" class="text-muted text-warning position-relative position-top-minus-5">Pending for Review: {{item.nameAtd}}</small>
                                </span>
                              </li>
                              <!--<li [ngClass]="model.published==2?'active':''" *ngIf="model.published==1|| model.published>1">
                                Under Review<br>
                                <small class="text-muted"></small>
                              </li>-->
                              <li>
                                MOM Created: {{model.initiatedBy}}<br>
                                <small class="text-muted">{{model.createDate |  date:'dd/MM/yyyy hh:mm a'}}</small>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <div class="mb-0">
                    <a class="btn btn-link text-secondary collapsed" data-toggle="collapse" data-target="#collapseTwo2" aria-expanded="false" aria-controls="collapseTwo2">
                      Meeting Discussion
                    </a>
                    <div class="position-absolute absolute-pos-btn py-2 px-4 mx-4 mt-1">
                      <a (click)="exportDiscussion()" class="btn btn-outline-success btn-sm"> <i class="ti ti-export"></i> Export Discussion</a>
                    </div>
                  </div>
                </div>
                <div id="collapseTwo2" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                  <div class="card-body actionPoint">
                    <div id="accordionSub" class="accordion-actionsection">

                      <div *ngIf="viewSelected" class="test">
                        <!-- <div class="text-secondary py-0">Meeting Discussion</div>
                        <p>This is the general Meeting Discussion text added by the initiator. The reviewers and approver can change or edit this.</p>-->
                        <div class="card">
                          <div class="card-header position-relative px-0 pb-0 border-0">
                            <div class=" rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="mainDiscussionPointList.length ===0">
                              <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                              <h5 class="py-4 text-center">No Data Available</h5>
                            </div>
                            <div class="btn p-0 w-100 text-left div-arrow border-0" *ngFor="let agenda of mainDiscussionPointList; let i = index" (click)="agenda.expanded=!agenda.expanded">
                              <div class="px-4 pb-3 position-relative">
                                <h6 class="mb-0 mt-2 card-title d-inline-block f-bold-dubai hinde-p-mb">
                                  <span class="float-left pr-1">{{i+1}}.</span> <span [innerHTML]="agenda.note" class="d-inline-block"></span>
                                </h6>
                                <span class="card-refresh position-absolute position-top-5 position-right-15 text-black pointer text-secondary">
                                  <!--<i *ngIf="getSubItems(agenda).length>0" class="fa fa-angle-down fa-lg"></i>-->
                                  <span (click)="openFileList(agenda.agendaUno,'ActionPoint')">
                                    <i class="la la-paperclip fa-lg mx-1 icon-rotate"></i> {{getFileList(agenda.agendaUno,'ActionPoint')}}
                                  </span>
                                </span>

                              </div>
                              <div class="bg-light border-top" *ngIf="agenda.expanded">
                                <div class="card-body py-0 mx-3">
                                  <div class="py-3" *ngFor="let subAction of getSubItems(agenda); let j = index">
                                    <h6 class="f-bold-dubai clearfix hinde-p-mb"><span class="float-left pr-1">{{i+1}}.{{j+1}}.</span> <span class="float-left" [innerHTML]="subAction.note"></span></h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--edit section start-->
                      <div *ngIf="editSelected" class="custom-tab">
                        <div class="row">
                          <div class="col-md-12 px-2">
                            <div class="text-right py-3">
                              <a class="bg-lighty-grey border-0 d-block p-2 rounded text-secondary hide-text-decoration pointer text-left" (click)="openAddActionPoint(false)"><i class="la la-plus"></i> Add Discussion</a>
                              <!--<a class="btn btn-outline-success btn-sm m-2" (click)="exportDiscussion()"><i class="ti ti-export"></i> Export Discussion</a>-->

                            </div>
                            <div class="custom-tab">
                              <div class=" rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="mainDiscussionPointList.length ===0">
                                <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                                <h5 class="py-4 text-center">No Data Available</h5>
                              </div>
                              <div class="my-3" cdkDropList (cdkDropListDropped)="onDropDiscussion($event)">
                                <div class="border rounded" *ngFor="let agenda of mainDiscussionPointList" cdkDrag cdkDragLockAxis="y">
                                  <div class="pt-2 border-bottom position-relative">
                                    <div class="px-3 pb-2 border-bottom">
                                      <h6 class="card-title d-inline f-bold-dubai text-editor-content" [innerHTML]="agenda.note"></h6>
                                      <div class="card-controls position-absolute position-top-0 position-right-15 text-secondary">
                                        <ul class="list-inline hide-arrow-drop mb-0">
                                          <li class="list-inline-item m-0 nav-item pointer"><a title="Edit" (click)="openEditActionPoint(agenda,false,'')"><i class="la la-edit fa-lg text-primary"></i></a></li>
                                          <li class="list-inline-item m-0 nav-item px-0 pointer upload-btn-wrapper position-bottom-minus-3"><a title="Attach File"><i class="fa mr-1 fa-paperclip icon-rotate-140 position-relative position-bottom-minus-5"></i><input type="file" id="myActionfile" class="file-upload" name="myActionfile" (change)="actionPointFileInput($event.target.files,agenda)" /> </a></li>
                                          <li class="list-inline-item m-0 nav-item pointer" (click)="openFileList(agenda.agendaUno,'ActionPoint')">
                                            ({{getFileList(agenda.agendaUno,'ActionPoint')}})
                                          </li>
                                          <li class="list-inline-item m-0 nav-item pointer"><a title="Delete" (click)="deleteActionPoints(agenda)"><i class="la la-trash-o fa-lg text-danger"></i></a></li>
                                          <li class="list-inline-item m-0 nav-item pointer">
                                            <a title="Reorder" class="nav-link p-0"><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i> </a>

                                          </li>
                                        </ul>
                                      </div>

                                      <!--<a class="pt-2 text-primary d-block" (click)="opensubActionPoint(agenda,false)"><i class="la la-plus"></i> Add a sub-point</a>-->
                                    </div>
                                    <div class="pt-2 px-4 bg-light" *ngFor="let subAction of getSubItems(agenda)">
                                      <div class="row">
                                        <div class="col-md-11 col-sm-10">
                                          <span class="card-title d-inline text-secondary f-regular-dubai" [innerHTML]="subAction.note"></span>
                                        </div>
                                        <div class="col-md-1 col-sm-2">
                                          <a class="text-danger pull-right" (click)="deleteActionPoints(subAction)" title="Delete"><i class="la la-trash fa-lg"></i></a>
                                          <a class="text-primary pull-right" (click)="openEditActionPoint(subAction,false,'')" title="Edit"><i class="la la-edit fa-lg"></i></a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--edit section end-->
                    </div>

                  </div>
                </div>
              </div>

              <div class="card" id="ActionPointSection">
                <div class="card-header" id="headingTwo">
                  <div class="mb-0">
                    <a class="btn btn-link text-secondary collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">Action Points</a>
                    <div class="position-absolute absolute-pos-btn py-2 px-4 mx-4 mt-1">
                      <a (click)="exportActionPoint()" class="btn btn-outline-success btn-sm"> <i class="ti ti-export"></i> Export Action</a>
                    </div>
                  </div>
                </div>
                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordion">
                  <div class="card-body actionPoint">
                    <div id="accordionSub" class="accordion-actionsection">
                      <div *ngIf="viewSelected">
                        <!--<div class="text-secondary py-2">Meeting Action Points</div>
                        <p>This is the general Meeting Discussion text added by the initiator. The reviewers and approver can change or edit this.</p>-->

                        <div class="card">
                          <div class="card-header position-relative px-0 pb-0" id="actionPointOne">
                            <div class="rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="mainActionPointList.length ===0">
                              <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                              <h5 class="py-4 text-center">No Data Available</h5>
                            </div>
                            <div *ngFor="let agenda of mainActionPointList; let i = index" class="btn px-0 w-100 text-left div-arrow pb-0 border-0" (click)="agenda.expanded=!agenda.expanded">
                              <div class="px-3 pb-3 border-bottom position-relative">
                                <h6 class="mb-0 card-title d-inline f-bold-dubai text-editor-content hinde-p-mb d-inline-block mb-2">
                                  <span>{{i+1}}. </span><span [innerHTML]="agenda.note" class="d-inline-block"></span>
                                </h6>
                                <div class="card-refresh position-absolute position-top-0 position-right-15 text-black pointer text-secondary">
                                  <ul class="list-inline hide-arrow-drop mb-0">
                                    <!--<li class="list-inline-item"><span class="pointer text-secondary"><i *ngIf="getSubItems(agenda).length>0" class="fa fa-angle-down fa-lg"></i></span></li>-->
                                    <li class="list-inline-item">
                                      <span (click)="openFileList(agenda.agendaUno,'ActionPoint')" class="card-refresh text-black pointer text-secondary">
                                        <i class="la la-paperclip fa-lg mx-1 icon-rotate"></i>{{getFileList(agenda.agendaUno,'ActionPoint')}}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                                <div class="p-0 f-regular-dubai">
                                  <span class="pr-2"><i class="la la-calendar-o fa-lg"></i> {{agenda.dueDate |  date:'dd/MM/yyyy'}}</span> | <span class="px-2"><i class="la la-user fa-lg"></i> {{agenda.userName}}</span> |
                                  <span class="px-2 text-primary" *ngIf="agenda.progress ==0">Not Started</span>
                                  <span class="px-2 text-primary" *ngIf="agenda.progress ==1">In Progress</span>
                                  <span class="px-2 text-success" *ngIf="agenda.progress ==2">Completed</span>
                                  <span class="px-2 text-primary" *ngIf="agenda.progress ==3">Waiting on others</span>
                                  <span class="px-2 text-primary" *ngIf="agenda.progress ==4">Deferred</span>
                                  <!--<span class="px-2 text-primary">{{agenda.priority}}</span>--> <span *ngIf="getSubItems(agenda).length >0 && agenda.expanded" class="float-md-right"><a class="text-primary">Close Sub Points</a></span>
                                  <span *ngIf="getSubItems(agenda).length >0 && !agenda.expanded" class="float-md-right"><a class="text-primary">Show Sub Points ({{getSubItems(agenda).length}})</a></span>
                                </div>
                              </div>
                              <div class="bg-light border-bottom" *ngIf="agenda.expanded">
                                <div class="card-body py-0 mx-3">

                                  <div class="py-3" *ngFor="let subAction of getSubItems(agenda); let j = index">
                                    <h6 class="f-bold-dubai clearfix hinde-p-mb"><span class="float-left pr-1">{{i+1}}.{{j+1}}.</span> <span class="float-left" [innerHTML]="subAction.note"></span></h6>
                                    <div class="p-0 f-regular-dubai">
                                      <span class="pr-2"><i class="la la-calendar-o fa-lg"></i> {{subAction.dueDate |  date:'dd/MM/yyyy'}}</span> | <span class="px-2"><i class="la la-user fa-lg"></i> {{subAction.userName}}</span>
                                      |<span class="px-2 text-primary" *ngIf="subAction.progress ==0">Not Started</span>
                                      <span class="px-2 text-primary" *ngIf="subAction.progress ==1">In Progress</span>
                                      <span class="px-2 text-primary" *ngIf="subAction.progress ==2">Completed</span>
                                      <span class="px-2 text-primary" *ngIf="subAction.progress ==3">Waiting on others</span>
                                      <span class="px-2 text-primary" *ngIf="subAction.progress ==4">Deferred</span>
                                      <!--<span class="px-2 text-primary">{{subAction.priority}}</span>-->
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                      <!--edit section start-->
                      <div *ngIf="editSelected" class="custom-tab">
                        <div class="row">
                          <div class="col-md-12 px-2">
                            <div class="text-right py-3">
                              <a class="bg-lighty-grey border-0 d-block p-2 rounded text-secondary hide-text-decoration pointer text-left" (click)="openAddActionPoint()"><i class="la la-plus"></i> Add Action Point</a>
                              <!--<a class="btn btn-outline-success btn-sm m-2" (click)="exportActionPoint()"><i class="ti ti-export"></i> Export Action</a>-->

                            </div>
                            <div class="custom-tab">
                              <div class="my-3">
                                <div class="rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="mainActionPointList.length ===0">
                                  <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                                  <h5 class="py-4 text-center">No Data Available</h5>
                                </div>
                                <div cdkDropList (cdkDropListDropped)="onDropAction($event)">
                                  <div class="border rounded mb-3" *ngFor="let agenda of mainActionPointList" cdkDrag cdkDragLockAxis="y">
                                    <div class="pt-2 position-relative">
                                      <div class="px-3 pb-2 border-bottom">
                                        <h6 class="card-title d-inline f-bold-dubai text-editor-content" [innerHTML]="agenda.note"></h6>
                                        <div class="card-controls position-absolute position-top-5 position-right-15 text-secondary">
                                          <ul class="list-inline hide-arrow-drop mb-0">
                                            <li class="list-inline-item m-0 nav-item pointer px-1" title="View File" (click)="openFileList(agenda.agendaUno,'ActionPoint')">
                                              ({{getFileList(agenda.agendaUno,'ActionPoint')}})
                                            </li>
                                            <li class="list-inline-item m-0 nav-item pointer text-danger"> <a title="Delete" (click)="deleteActionPoints(agenda)"><i class="la la-trash fa-lg"></i></a></li>
                                            <li class="list-inline-item m-0 nav-item all-scroll" ngbDropdown>
                                              <a title="Reorder" class="nav-link p-0 all-scroll" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i><i class="la la-ellipsis-v fa-lg w-7 all-scroll"></i></a>
                                            </li>
                                          </ul>
                                        </div>
                                        <div class="row">
                                          <div class="col-lg-3 col-md-4 col-sm-4">
                                            <div class="form-group">
                                              <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                  <div class="form-control border-0"><i class="la la-calendar-check-o fa-lg"></i></div>
                                                </div>
                                                <input title="Edit" (click)="openEditActionPoint(agenda,true,'Action')" type="text" class="form-control pointer" readonly value="{{agenda.dueDate |  date:'dd/MM/yyyy'}}" id="agendaDueDate" placeholder="Set Due Date">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-lg-3 col-md-4 col-sm-4">
                                            <div class="form-group">
                                              <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                  <div class="form-control border-0"><i class="la la-user-alt fa-lg"></i></div>
                                                </div>
                                                <input title="Edit" (click)="openEditActionPoint(agenda,true,'Action')" type="text" class="form-control pointer" readonly [(ngModel)]="agenda.userName" placeholder="Assign Responsibility">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-lg-3 col-md-4 col-sm-4 px-0">
                                            <div title="Edit" (click)="openEditActionPoint(agenda,true,'Action')" class="gray-radius-btn d-sm-flex py-2 float-left text-white pointer" [ngClass]="gerPriortyColor(agenda.priority)">
                                              <i class="la la-info-circle fa-lg mx-1"></i>
                                              {{agenda.priority}}
                                            </div>
                                          </div>
                                        </div>
                                        <a class="pt-2 text-primary d-block" (click)="opensubActionPoint(agenda)"><i class="la la-plus"></i> Add a sub-point</a>
                                      </div>
                                      <div class="py-2 px-4 border-bottom position-relative bg-light" *ngFor="let subAction of getSubItems(agenda)">
                                        <h6 class="card-title d-inline text-secondary f-regular-dubai text-editor-content" [innerHTML]="subAction.note"></h6>
                                        <div class="card-controls position-absolute position-top-5 position-right-15 text-secondary">
                                          <ul class="list-inline hide-arrow-drop mb-0">
                                            <li class="list-inline-item m-0">
                                              <a class="text-danger" (click)="deleteActionPoints(subAction)" title="Delete"><i class="la la-trash fa-lg"></i></a>
                                            </li>
                                          </ul>
                                        </div>
                                        <div class="row">
                                          <div class="col-lg-3 col-md-4 col-sm-4">
                                            <div class="form-group">
                                              <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                  <div class="form-control border-0"><i class="la la-calendar-check-o fa-lg"></i></div>
                                                </div>
                                                <input title="Edit" (click)="openEditActionPoint(subAction,true,'Sub')" type="text" class="form-control pointer" readonly value="{{subAction.dueDate |  date:'dd/MM/yyyy'}}" placeholder="Set Due Date">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-lg-3 col-md-4 col-sm-4">
                                            <div class="form-group">

                                              <div class="input-group mb-2">
                                                <div class="input-group-prepend">
                                                  <div class="form-control border-0"><i class="la la-user-alt fa-lg"></i></div>
                                                </div>
                                                <input title="Edit" (click)="openEditActionPoint(subAction,true,'Sub')" type="text" class="form-control pointer" readonly [(ngModel)]="subAction.userName" placeholder="Assign Responsibility">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-lg-3 col-md-4 col-sm-4 px-0">
                                            <div title="Edit" (click)="openEditActionPoint(subAction,true,'Sub')" class="gray-radius-btn d-sm-flex float-left py-2 text-white pointer" [ngClass]="gerPriortyColor(subAction.priority)">
                                              <i class="la la-info-circle fa-lg mx-1"></i>
                                              {{subAction.priority}}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--edit section end-->
                    </div>
                  </div>
                </div>
              </div>




              <div class="card">
                <div class="card-header" id="headingThree">

                  <a class="btn btn-link text-secondary collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Attendees
                  </a>
                  <div class="position-absolute absolute-pos-btn py-2 px-4 mx-4 mt-1"><a (click)="exportAttendee()" class="btn btn-outline-success btn-sm"><i class="ti ti-export"></i> Export Attendees</a></div>
                </div>
                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordion">

                  <div class="card-body attendeesListLoader">
                    <!--edit attendees start-->
                    <div>
                      <div class="row">
                        <div class="col-md-12">
                          <!--<div class="text-right py-3">
                            <a class="btn btn-sm btn-outline-success" (click)="exportAttendee()"><i class="ti ti-export"></i> Export Attendees</a>
                          </div>-->
                          <div>
                            <ul class="nav nav-border-tabs px-0" id="myTab" role="tablist" *ngIf="editSelected">
                              <li class=" f-bold-dubai text-secondary pr-2">Add Attendee :</li>
                              <li class="nav-item"><a class="nav-link" id="internal-tab" (click)="onChangesubTab('internal')" [ngClass]="{ 'active':addTab1}"  data-toggle="tab" href="#internal" role="tab" aria-controls="internal" aria-selected="true">Internal</a></li>
                              <li class="nav-item"><a class="nav-link" id="external-tab" (click)="onChangesubTab('external')" [ngClass]="{ 'active':addTab2}" data-toggle="tab" href="#external" role="tab" aria-controls="attendees" aria-selected="false">External</a></li>
                            </ul>
                            <div class="tab-content px-0" id="myTabContent" *ngIf="editSelected">
                              <div class="tab-pane fade" [ngClass]="{ 'active show':addTab1}" id="internal" role="tabpanel" aria-labelledby="internal-tab">
                                <form name="ia" id="ia" #ia="ngForm" (ngSubmit)="onSubmitInternal(ia,'Attendee',selectedInternalUser)" novalidate>
                                  <div class="row py-2 custom-tab">
                                    <div class="col-md-3">
                                      <div class="form-group">
                                        <ng-select [items]="UserList" class="form-control p-0"
                                                   bindLabel="fullAttendeeName"
                                                   bindValue="userselUno"
                                                   required #selectInternalUser="ngModel"
                                                   [(ngModel)]="selectedInternalUser"
                                                   id="selectInternalUser"
                                                   name="selectInternalUser"
                                                   [ngClass]="{ 'error':isSubmitInternal  && selectInternalUser.invalid }"
                                                   [multiple]="false"
                                                   [searchable]="true"
                                                   [searchFn]="customSearchFn"
                                                   [virtualScroll]="true"
                                                   [minTermLength]="3"
                                                   placeholder="Search attendees by Name or PR or Email">
                                          <ng-template ng-option-tmp let-item="item">
                                            <div class="line">{{item.fullAttendeeName}}</div>
                                            <div class="line-email">{{item.emailAtd}}</div>
                                            <div class="line-designation">{{item.designation}} {{item.division}}</div>
                                          </ng-template>
                                        </ng-select>
                                        <div *ngIf="isSubmitInternal && selectInternalUser.invalid">
                                          <div class="text-danger"> Select the user</div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div class="form-group">
                                        <button class="btn btn-success px-4">Add</button>
                                        <!--<button type="button" (click)="cancelAttendee()" class="btn btn-outline-danger ml-2"><i class="la la-times"></i> Cancel</button>-->
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                              <div class="tab-pane fade" [ngClass]="{ 'active show':addTab2}" id="external" role="tabpanel" aria-labelledby="external-tab">
                                <form name="eu" id="eu" #eu="ngForm" (ngSubmit)="onSubmitExternal(eu)" novalidate>
                                  <div class="row py-2 custom-tab">
                                    <div class="col-md-2">
                                      <div class="form-group">
                                        <input class="form-control" type="text" placeholder="Name" required #uname="ngModel"
                                               [(ngModel)]="attendeeModel.nameAtd"
                                               id="uname"
                                               name="uname"
                                               [ngClass]="{ 'error':isSubmitExternal  && uname.invalid }">
                                      </div>
                                      <div *ngIf="isSubmitExternal && uname.invalid">
                                        <div class="text-danger"> Name is required</div>
                                      </div>
                                    </div>
                                    <div class="col-md-2">
                                      <div class="form-group">
                                        <input class="form-control" type="text" placeholder="Organization" required #organization="ngModel"
                                               [(ngModel)]="attendeeModel.companyAtd"
                                               id="organization"
                                               name="organization"
                                               [ngClass]="{ 'error':isSubmitExternal  && organization.invalid }">
                                      </div>
                                      <div *ngIf="isSubmitExternal && organization.invalid">
                                        <div class="text-danger"> Organization is required</div>
                                      </div>
                                    </div>
                                    <div class="col-md-2">
                                      <div class="form-group">
                                        <input class="form-control" type="email" placeholder="Email" required #emailAddr="ngModel"
                                               [(ngModel)]="attendeeModel.emailAtd"
                                               id="emailAddr"
                                               name="emailAddr"
                                               pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                                               [ngClass]="{ 'error':isSubmitExternal  && emailAddr.invalid }">
                                      </div>

                                      <div *ngIf="isSubmitExternal && emailAddr.invalid">
                                        <div class="text-danger"> Email is required</div>

                                      </div>
                                      <div *ngIf="emailAddr.touched">

                                        <p class="text-danger" *ngIf="emailAddr.errors?.pattern">This is not a valid Email!!!</p>
                                      </div>
                                    </div>
                                    <div class="col-md-2">
                                      <div class="form-group">
                                        <input class="form-control" type="text" placeholder="Contact Number" #contactno="ngModel"
                                               [(ngModel)]="attendeeModel.contactAtd"
                                               id="contactno"
                                               name="contactno">
                                      </div>
                                    </div>
                                    <div class="col-md-2">
                                      <div class="form-group">
                                        <input class="form-control" type="text" placeholder="Designation" required #designation="ngModel"
                                               [(ngModel)]="attendeeModel.designation"
                                               id="designation"
                                               name="designation"
                                               [ngClass]="{ 'error':isSubmitExternal  && designation.invalid }">
                                      </div>
                                      <div *ngIf="isSubmitExternal && designation.invalid">
                                        <div class="text-danger"> Designation is required</div>
                                      </div>
                                    </div>
                                    <div class="col-md-2">
                                      <div class="form-group">
                                        <button class="btn btn-success px-4"> Add</button>
                                        <!--<button type="button" (click)="cancelAttendee()" class="btn btn-outline-danger ml-2"><i class="la la-times"></i> Cancel</button>-->
                                      </div>
                                    </div>

                                  </div>
                                </form>
                              </div>
                            </div>
                            <div *ngIf="attendeeList==null ||attendeeList.length<=0" class="border px-3 py-4 text-center rounded text-secondary">
                              <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                              <h5 class="py-4 text-center">No Data Available</h5>
                            </div>
                            <div class="table-popover-view table-responsive-lg" id="hgtTable" *ngIf="!editSelected">
                              <table class="table border-0 table-border-td" *ngIf="attendeeList!=null && attendeeList.length>0" [ngClass]="tableHeightClass">
                                <thead>
                                  <tr>
                                    <th scope="col" class="border-0 w-35">Name</th>
                                    <th scope="col" class="border-0">PR&nbsp;Number</th>
                                    <th scope="col" class="border-0 w-15">Designation</th>
                                    <th scope="col" class="border-0">Attendance</th>
                                    <th scope="col" class="border-0">Role</th>
                                    <th scope="col" class="border-0">Signature</th>
                                    <th scope="col" class="border-0 px-4"> {{editSelected?'Action':'Info'}}</th>
                                  </tr>
                                </thead>
                                <tbody>

                                  <tr *ngFor="let item of attendeeList">
                                    <td class="border-left position-relative">
                                      <div id="{{item.attendeesUnoAtd}}" class="d-none card mb-0 bg-white p-3 border profiledetails">
                                        <span class="position-absolute position-right-10 close-card pointer" (click)="closeCard(item.attendeesUnoAtd)"><i class="la la-close"></i></span>
                                        <div class="row profile-scroll">
                                          <div class="col-md-3 pr-0">
                                            <span><img class="img-fluid rounded-circle wh-80" [src]="item.picture" alt="Profile" /></span>
                                          </div>
                                          <div class="col-md-9">
                                            <div class="border-bottom">
                                              <h5 class="mb-0">{{item.nameAtd}}</h5>
                                              <p class="py-0 my-0 text-secondary">
                                                {{item.designation}}<br>
                                                <small><i class="la la-id-badge"></i>   {{item.prNumberAtd}}</small> <!--| <small><i class="la la-comments"></i>   Start Chat</small>-->
                                              </p>
                                            </div>
                                            <h5 class="pt-2 mb-0">Contact information</h5>
                                            <div class="row text-secondary">
                                              <div class="col-md-3"><i class="la la-envelope"></i> Email</div>
                                              <div class="col-md-9"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
                                            </div>
                                            <div class="row text-secondary">
                                              <div class="col-md-3"> Office</div>
                                              <div class="col-md-9">{{item.companyAtd}}</div>
                                            </div>
                                            <div class="row text-secondary">
                                              <div class="col-md-3"><i class="la la-phone-square"></i>Phone</div>
                                              <div class="col-md-9">{{item.contactAtd==0?'-':item.contactAtd}}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-1 text-brown f-bold-dubai mx-2 border pointer text-center" (click)="profileCard(item.attendeesUnoAtd)">{{getShortName(item.nameAtd)}}</span>  <span class="pointer" (click)="profileCard(item.attendeesUnoAtd)">{{item.nameAtd}}</span>
                                    </td>
                                    <td>{{item.prNumberAtd}}</td>
                                    <td>{{item.designation}}</td>
                                    <td>
                                      <select [(ngModel)]="item.status" #status="ngModel" [disabled]="!editSelected" [class.custom-select-color]="!editSelected"
                                              id="status" (change)="ChangeAttendeeStatus(item)"
                                              name="status" class="custom-select border-0">
                                        <option value="Present">Present </option>
                                        <option value="On Behalf">{{'On Behalf ' + ((item.status=='On Behalf')? '-('+item.apologizedReason+')':'') }}</option>
                                        <option value="Absent">Absent</option>
                                        <option value="Apologized">Apologized</option>
                                        <option value="External">External</option>
                                      </select>
                                    </td>
                                    <td>
                                      <select class="custom-select border-0" [(ngModel)]="item.role" #role="ngModel" [disabled]="!editSelected" [class.custom-select-color]="!editSelected"
                                              (change)="UpdateAttendees('role',item.role,item)"
                                              id="role" name="role">
                                        <option value="Organizer">Organizer </option>
                                        <option value="Attendee">Attendee</option>
                                        <option value="Guest">Guest</option>
                                        <option value="Has Action (Non-attendee)">Has Action (Non-attendee)</option>
                                      </select>
                                    </td>
                                    <td>
                                      <a title="Click to sign here" (click)="UpdateAttendees('signature','Signed',item)" *ngIf="item.userselUno==loginUserId && (item.signImage==null || item.signImage=='')" class="text-primary m-1 pointer "><i class="la la-pen-fancy fa-lg"></i></a>
                                      <span *ngIf="item.userselUno!=loginUserId ">{{ (item.signImage==null || item.signImage=='') ?'Not Signed':'Signed' }}</span>
                                      <span class="text-success" *ngIf="item.userselUno==loginUserId && (item.signImage!=null && item.signImage!='') ">Signed</span>
                                    </td>


                                    <td class="border-right text-center">
                                      <span *ngIf="editSelected" class="d-block">
                                        <a *ngIf="item.status=='Apologized'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-info-circle fa-lg"></i></a>
                                        <a *ngIf="item.status=='On Behalf'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary  m-0 text-right d-inline"><i class="la la-user fa-lg"></i></a>
                                        <a *ngIf="(item.prNumberAtd==null || item.prNumberAtd=='')" (click)="editAttendee(item)" class="text-primary  m-0 text-right d-inline" title="Edit"><i class="la la-edit fa-lg"></i></a>
                                        <a *ngIf="item.userselUno!=loginUserId" (click)="delAttendee(item.attendeesUnoAtd)" class="text-danger  m-0 text-right d-inline" title="Delete"><i class="la la-trash fa-lg"></i></a>
                                      </span>

                                      <span *ngIf="!editSelected" class="d-block">
                                        <a *ngIf="item.status=='Apologized'" (click)="openResonModal(templateUserDetail,item.apologizedReason)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-info-circle fa-lg"></i></a><a *ngIf="item.status=='On Behalf'" (click)="openResonModal(templateUserDetail,'On Behalf'+item.apologizedReason)" [title]="'On Behalf'+item.apologizedReason" class="text-primary m-0 text-right  d-inline"><i class="la la-user fa-lg"></i></a>
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="table-popover-view table-responsive-lg" id="hgtTable" *ngIf="editSelected">
                              <table class="table border-0 table-border-td" *ngIf="attendeeList!=null && attendeeList.length>0" [ngClass]="tableHeightClass">
                                <thead>
                                  <tr>
                                    <th scope="col" class="border-0 w-35">Name</th>
                                    <th scope="col" class="border-0">PR&nbsp;Number</th>
                                    <th scope="col" class="border-0 w-15">Designation</th>
                                    <th scope="col" class="border-0">Attendance</th>
                                    <th scope="col" class="border-0">Role</th>
                                    <th scope="col" class="border-0">Signature</th>
                                    <th scope="col" class="border-0 px-4"> {{editSelected?'Action':'Info'}}</th>
                                  </tr>
                                </thead>
                                <tbody cdkDropList (cdkDropListDropped)="onDrop($event)">

                                  <tr *ngFor="let item of attendeeList" cdkDrag cdkDragLockAxis="y">
                                    <td class="border-left position-relative">
                                      <div id="{{item.attendeesUnoAtd}}" class="d-none card mb-0 bg-white p-3 border profiledetails">
                                        <span class="position-absolute position-right-10 close-card pointer" (click)="closeCard(item.attendeesUnoAtd)"><i class="la la-close"></i></span>
                                        <div class="row profile-scroll">
                                          <div class="col-md-3 pr-0">
                                            <span><img class="img-fluid rounded-circle wh-80" [src]="item.picture" alt="Profile" /></span>
                                          </div>
                                          <div class="col-md-9">
                                            <div class="border-bottom">
                                              <h5 class="mb-0">{{item.nameAtd}}</h5>
                                              <p class="py-0 my-0 text-secondary">
                                                {{item.designation}}<br>
                                                <small><i class="la la-id-badge"></i>   {{item.prNumberAtd}}</small> <!--| <small><i class="la la-comments"></i>   Start Chat</small>-->
                                              </p>
                                            </div>
                                            <h5 class="pt-2 mb-0">Contact information</h5>
                                            <div class="row text-secondary">
                                              <div class="col-md-3"><i class="la la-envelope"></i> Email</div>
                                              <div class="col-md-9"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
                                            </div>
                                            <div class="row text-secondary">
                                              <div class="col-md-3"> Office</div>
                                              <div class="col-md-9">{{item.companyAtd}}</div>
                                            </div>
                                            <div class="row text-secondary">
                                              <div class="col-md-3"><i class="la la-phone-square"></i>Phone</div>
                                              <div class="col-md-9">{{item.contactAtd==0?'-':item.contactAtd}}</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-1 text-brown f-bold-dubai mx-2 border pointer text-center" (click)="profileCard(item.attendeesUnoAtd)">{{getShortName(item.nameAtd)}} </span>
                                      <span class="pointer" (click)="profileCard(item.attendeesUnoAtd)">{{item.nameAtd}}</span>
                                    </td>
                                    <td>{{item.prNumberAtd}}</td>
                                    <td>{{item.designation}}</td>
                                    <td>
                                      <select [(ngModel)]="item.status" #status="ngModel" [disabled]="!editSelected"
                                              id="status" (change)="ChangeAttendeeStatus(item)"
                                              name="status" class="custom-select border-0">
                                        <option value="Present">Present </option>
                                        <option value="On Behalf">{{'On Behalf ' + ((item.status=='On Behalf')? '-('+item.apologizedReason+')':'') }}</option>
                                        <option value="Absent">Absent</option>
                                        <option value="Apologized">Apologized</option>
                                        <option value="External">External</option>
                                      </select>
                                    </td>
                                    <td>
                                      <select class="custom-select border-0" [(ngModel)]="item.role" #role="ngModel" [disabled]="!editSelected"
                                              (change)="UpdateAttendees('role',item.role,item)"
                                              id="role" name="role">
                                        <option value="Organizer">Organizer </option>
                                        <option value="Attendee">Attendee</option>
                                        <option value="Guest">Guest</option>
                                        <option value="Has Action (Non-attendee)">Has Action (Non-attendee)</option>
                                      </select>
                                    </td>
                                    <td>
                                      <a title="Click to sign here" (click)="UpdateAttendees('signature','Signed',item)" *ngIf="item.userselUno==loginUserId && (item.signImage==null || item.signImage=='')" class="text-primary m-1 pointer "><i class="la la-pen-fancy fa-lg"></i></a>
                                      <span *ngIf="item.userselUno!=loginUserId ">{{ (item.signImage==null || item.signImage=='') ?'Not Signed':'Signed' }}</span>
                                      <span *ngIf="item.userselUno==loginUserId && (item.signImage!=null && item.signImage!='') ">Signed</span>
                                    </td>


                                    <td class="border-right text-center">
                                      <span *ngIf="editSelected" class="d-block">
                                        <a *ngIf="item.status=='Apologized'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-info-circle fa-lg"></i></a>
                                        <a *ngIf="item.status=='On Behalf'" (click)="attendeeReason(item)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-user fa-lg"></i></a>
                                        <a *ngIf="(item.prNumberAtd==null || item.prNumberAtd=='')" (click)="editAttendee(item)" class="text-primary m-0 text-right d-inline" title="Edit"><i class="la la-edit fa-lg"></i></a>
                                        <a *ngIf="item.userselUno!=loginUserId" (click)="delAttendee(item.attendeesUnoAtd)" class="text-danger m-0 text-right d-inline" title="Delete"><i class="la la-trash fa-lg"></i></a>
                                      </span>

                                      <span *ngIf="!editSelected" class="d-block">
                                        <a *ngIf="item.status=='Apologized'" (click)="openResonModal(templateUserDetail,item.apologizedReason)" [title]="item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-info-circle fa-lg"></i></a>
                                        <a *ngIf="item.status=='On Behalf'" (click)="openResonModal(templateUserDetail,'On Behalf'+item.apologizedReason)" [title]="'On Behalf'+item.apologizedReason" class="text-primary m-0 text-right d-inline"><i class="la la-user fa-lg"></i></a>
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="text-center pb-5" *ngIf="!disableMoreAtd" (click)="getAttendeeList()"><a class="btn btn-sm btn-outline-secondary">Load More..</a></div>
                        </div>
                      </div>
                    </div>
                    <!--edit attendees end-->
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFour">
                  <a class="btn btn-link text-secondary collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Workflow
                  </a>
                </div>
                <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordion">
                  <div class="card-body mb-4">
                    <div>
                      <div class="work-flow-section col-md-12">
                        <div class="work-flow-status form-row">
                          <div class="step step-one active">
                            <span class="icon"></span>
                            <span class="text f-bold-dubai">Initiator</span>
                            <div class="form-group pt-3">
                              <span class="f-bold-dubai mt-0 d-block">{{model.initiatedBy}}</span>
                              <small class="text-muted position-relative position-top-minus-5">Initiated on {{model.createDate |  date:'dd/MM/yyyy '}}</small>
                            </div>

                          </div>
                          <div class="step step-two active">
                            <span class="icon"></span>
                            <span class="text f-bold-dubai"> Reviewer</span>
                            <div class=" pt-3">
                              <div class="form-group" *ngFor="let item of reviewerList; let i = index ">
                                <span class="text f-bold-dubai text-dark mt-0">{{i+1}} . {{item.nameAtd}}</span>
                                <small *ngIf=" item.signImage!=''&& item.signImage!=null" class="text-muted">Reviewed on {{item.modifiedOn |  date:'dd/MM/yyyy hh:mm a'}}</small>
                                <small *ngIf=" item.signImage==''|| item.signImage==null" class="text-muted text-warning position-relative position-top-minus-5">Pending</small>
                              </div>
                            </div>
                            <div class="form-group" *ngIf="reviewerList.length==0">
                              <span class="text f-bold-dubai text-dark mt-0" *ngIf="model!=null && model.published ==1">{{model.initiatedBy}}</span>
                              <small class="text-muted" *ngIf="model!=null && model.published ==1">Reviewed on {{model.modifiedOn |  date:'dd/MM/yyyy'}}</small>
                            </div>
                          </div>
                          <div class="step step-three active">
                            <span class="icon"></span>
                            <span class="text f-bold-dubai"> Approver </span>
                            <div class="form-group pt-3" *ngIf="approver!=null">
                              <span class="text f-bold-dubai text-dark mt-0">{{approver.nameAtd}}</span>
                              <small *ngIf="approver!=null && approver.signImage!=''&& approver.signImage!=null" class="text-muted">Approved on {{approver.modifiedOn |  date:'dd/MM/yyyy hh:mm a'}}</small>
                              <small *ngIf="approver!=null && (approver.signImage==''|| approver.signImage==null)" class="text-muted text-warning d-block">Pending</small>

                            </div>
                            <div class="form-group pt-3" *ngIf="approver==null">
                              <span class="text f-bold-dubai text-dark mt-0" *ngIf="model!=null && model.published ==1">{{model.initiatedBy}}</span>
                              <small class="text-muted" *ngIf="model!=null && model.published ==1">Approved on {{model.modifiedOn |  date:'dd/MM/yyyy'}}</small>
                            </div>

                          </div>
                          <div class="step step-four active">
                            <span class="icon"></span> <span class="text f-bold-dubai">Publish</span>
                            <div class="text-dark form-group pt-3" *ngIf="model!=null && model.published ==1">
                              <span class="f-bold-dubai mt-0">{{model.initiatedBy}}</span>
                              <small class="text-muted d-block">Published on {{model.modifiedOn |  date:'dd/MM/yyyy'}}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--edit workflow start-->
                    <!--<div *ngIf="editSelected">
                      <div class="row">
                        <div class="col-md-12">
                          <h5 class="text-secondarytext-secondary custom-tab f-bold-dubai text-secondary py-3 px-3">Set the Workflow:</h5>
                          <div class="work-flow-section col-md-12">
                            <div class="work-flow-status form-row">
                              <div class="step step-one active">
                                <span class="icon"></span>
                                <span class="text f-bold-dubai">Initiator</span>
                                <div class="form-group pt-3">
                                  <input type="text" readonly [value]="model.initiatedBy" class="form-control col-md-8">
                                </div>
                              </div>
                              <div class="step step-two active">
                                <span class="icon"></span>
                                <span class="text f-bold-dubai"> Reviewer(s)<span class="text-danger">*</span></span>
                                <div class="form-group">
                                  <form name="rwForm" class="pt-3" id="rwForm" #rwForm="ngForm" novalidate>

                                    <div class="form-group" *ngIf="reviewerList && reviewerList.length!=5">
                                      <ng-select [items]="UserList" class="form-control col-md-10 p-0"
                                                 bindLabel="fullAttendeeName"
                                                 bindValue="userselUno"
                                                 required #selectReviewer="ngModel"
                                                 [(ngModel)]="selectedReviewer"
                                                 id="selectReviewer"
                                                 name="selectReviewer"
                                                 [ngClass]="{ 'error':isSubmitReview  && selectReviewer.invalid }"
                                                 [multiple]="false"
                                                 [searchable]="true"
                                                 [virtualScroll]="true"
                                                 [minTermLength]="3"
                                                 (change)="onSubmitReviewer(rwForm,'Reviewer',selectedReviewer);"
                                                 placeholder=" Select the Reviewer">
                                      </ng-select>
                                      <div *ngIf="isSubmitReview && selectReviewer.invalid">
                                        <div class="text-danger"> Select the Reviewer</div>
                                      </div>
                                    </div>
                                  <div class="form-group" *ngIf="reviewerList && reviewerList.length!=5">
                                      <a class="text-secondary pointer my-2 d-block" (click)="onSubmitReviewer(rwForm,'Reviewer',selectedReviewer);"><i class="la la-plus"></i> Add Reviewer</a>
                                    </div>
                                    <div class="form-group" *ngFor="let item of reviewerList">
                                      <span class="d-inline-flex col-md-12 pl-0 position-relative"> <input type="email" [value]="item.nameAtd" readonly class="form-control pr-4"> <a (click)="delAttendee(item.attendeesUnoAtd)" class="text-secondary m-1 text-right position-absolute position-right-15 position-top-5 bg-lighty-grey"><i class="la la-close fa-lg"></i></a></span>
                                    </div>

                                  </form>
                                </div>


                              </div>
                              <div class="step step-three active">
                                <span class="icon"></span>
                                <span class="text f-bold-dubai"> Approver <span class="text-danger">*</span></span>
                                <div class="form-group pt-3">
                                  <form name="aprForm" id="aprForm" #aprForm="ngForm" novalidate>
                                    <div class="form-group" *ngIf="approver==null">
                                      <ng-select [items]="UserList" class="form-control col-md-10 p-0"
                                                 bindLabel="fullAttendeeName"
                                                 bindValue="userselUno"
                                                 required #selectApprover="ngModel"
                                                 [(ngModel)]="selectedApprover"
                                                 id="selectApprover"
                                                 name="selectApprover"
                                                 [ngClass]="{ 'error':isSubmitApprover  && selectApprover.invalid }"
                                                 [multiple]="false"
                                                 [searchable]="true"
                                                 [virtualScroll]="true"
                                                 [minTermLength]="3"
                                                 (change)="onSubmitApprover(aprForm,'Approver',selectedApprover);"
                                                 placeholder=" Select the Approver">
                                      </ng-select>
                                      <div *ngIf="isSubmitApprover && selectApprover.invalid">
                                        <div class="text-danger"> Select the Approver</div>
                                      </div>
                                    </div>
                                    <div class="form-group " *ngIf="approver!=null">
                                      <span class="d-inline-flex col-12 pl-0 position-relative"> <input type="email" [value]="approver.nameAtd" readonly class="form-control pr-4"> <a (click)="delAttendee(approver.attendeesUnoAtd)" class="text-secondary m-1 text-right position-absolute position-right-15 position-top-5 bg-lighty-grey"><i class="la la-close fa-lg"></i></a></span>
                                    </div>
                                   <div class="form-group" *ngIf="approver==null">
                                      <a class="text-secondary pointer my-2 d-block" (click)="onSubmitApprover(aprForm,'Approver',selectedApprover);"><i class="la la-plus"></i> Add Approver</a>
                                    </div>
                                  </form>
                                </div>
                              </div>
                              <div class="step step-four active"> <span class="icon"></span> <span class="text f-bold-dubai">Publish</span> </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label for="follow-up">Follow-up</label>
                              <form name="flwForm" id="flwForm" #flwForm="ngForm" novalidate>

                                <div class="form-group" *ngIf="followerList && followerList.length!=5">
                                  <ng-select [items]="UserList" class="form-control col-md-10 p-0"
                                             bindLabel="fullAttendeeName"
                                             bindValue="userselUno"
                                             required #selectFollower="ngModel"
                                             [(ngModel)]="selectedFollower"
                                             id="selectFollower"
                                             name="selectFollower"
                                             [ngClass]="{ 'error':isSubmitFollower  && selectFollower.invalid }"
                                             [multiple]="false"
                                             [searchable]="true"
                                             [virtualScroll]="true"
                                             [minTermLength]="3"
                                             placeholder=" Select the Follower">
                                  </ng-select>
                                  <div *ngIf="isSubmitFollower && selectFollower.invalid">
                                    <div class="text-danger"> Select the Follower</div>
                                  </div>
                                </div>
                                <div class="form-group " *ngFor="let item of followerList">
                                  <span class="d-inline-flex"> <input type="email" [value]="item.nameAtd" readonly class="form-control col-md-8"> <a (click)="delAttendee(item.attendeesUnoAtd)" class="text-danger col-md-1 m-1 text-right"><i class="la la-trash fa-lg"></i></a></span>
                                </div>
                                <div class="form-group" *ngIf="followerList && followerList.length!=5">
                                  <a class="text-secondary pointer my-2 d-block" (click)="onSubmitFollower(flwForm,'Follower',selectedFollower);"><i class="la la-plus"></i> Add Follow-up</a>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-8 py-4 px-4 mx-1">
                          <h5 class="text-secondarytext-secondary custom-tab f-bold-dubai text-secondary py-3">Workflow Settings:</h5>
                          <ul class="list-group list-group-flush">
                            <li class="list-group-item mb-1 px-0">
                              Publish without Review and Approve<br />
                              <small class="text-secondary">You will be signed as the reviewer and approver</small>
                              <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                                <input type="checkbox" [(ngModel)]="model.workFlowCondition1" (change)="model.workFlowCondition2=false;model.workFlowCondition3=false;model.workFlowCondition4=false;onSubmitWorkFlow();" class="custom-control-input" id="customSwitch1">
                                <label class="custom-control-label" for="customSwitch1"></label>
                              </div>

                            </li>
                            <li class="list-group-item mb-1 px-0">
                              Auto-send to Approver after Reviewed (by all reviewers)
                              <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                                <input type="checkbox" [(ngModel)]="model.workFlowCondition2" (change)="model.workFlowCondition1=false;onSubmitWorkFlow();" [readonly]="model.workFlowCondition1" class="custom-control-input" id="customSwitch4">
                                <label class="custom-control-label" for="customSwitch4"></label>
                              </div>

                            </li>
                            <li class="list-group-item mb-1 px-0">
                              Auto-publish after Approved
                              <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                                <input type="checkbox" (change)="model.workFlowCondition1=false;model.workFlowCondition4=false;onSubmitWorkFlow();" [(ngModel)]="model.workFlowCondition3" class="custom-control-input" id="customSwitch2">
                                <label class="custom-control-label" for="customSwitch2"></label>
                              </div>
                            </li>
                            <li class="list-group-item border-bottom px-0">
                              Send for signature to all attendees<br>
                              <small class="text-secondary">All attendees will be required to review and sign the MOM before it can published</small>
                              <div class="custom-control custom-switch custom-switch-md custom-green-swith float-right">
                                <input type="checkbox" [(ngModel)]="model.workFlowCondition4" (change)="model.workFlowCondition1=false;model.workFlowCondition3=false;onSubmitWorkFlow();" class="custom-control-input" id="customSwitch3">
                                <label class="custom-control-label" for="customSwitch3"></label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>


                    </div>-->
                    <!--edit workflow end-->
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="tab-pane fade" [ngClass]="{ 'active show':momTab2}" id="chat-tab" role="tabpanel" aria-labelledby="chat-tab">
          <div class="row">
            <div class="col-md-12 py-3">
              <div class="accordion accordion-menu" id="accordionChat">
                <div class="card">
                  <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                      <a class="btn btn-link text-secondary" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Chat
                      </a>
                    </h5>
                  </div>

                  <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionChat">
                    <div class="card-body pt-0 pb-1 h-100vh1">
                      <div class="row">
                        <div class="col-md-8 offset-md-2 bg-white-light chat-min-hgt">
                          <!--<div class="text-center d-block middel-line bg-white-light my-2"><small class="position-relative bg-white-light px-4">Today</small></div>-->
                          <div class="py-2 mb-4 pb-4 chat-overflow-scroll">
                            <div class="clearfix" *ngFor="let cmtObj of commentList; let cmtIndex = index;">
                              <div class="my-4 px-3 float-sm-left name-tag position-relative" *ngIf="cmtObj.userName!=loginUsrName">
                                <span class="border rounded-circle text-warning float-sm-left f-bold-dubai p-1 bg-light">{{getShortName(cmtObj.userName)}}</span>
                                <div class="border p-2 mx-4 bg-light rounded-top-right-medium rounded-bottom-right-medium rounded-bottom-left-medium">
                                  <small class="d-block text-secondary">
                                    {{cmtObj.userName}} {{cmtObj.cmtDate | date:'dd/MM/yyyy hh:mm a'}}
                                    <i *ngIf="cmtObj.chatType==0" title="Everyone" class="ti ti-unlock fa-lg mx-1"></i>
                                    <i *ngIf="cmtObj.chatType==1" title="Self" class="la la-file icon-rotate-180 text-primary fa-lg mx-1"></i>
                                    <i *ngIf="cmtObj.chatType==2" title="Private" class="ti ti-lock text-success fa-lg mx-1"></i>
                                  </small>
                                  <p class="d-inline-flex m-0">{{cmtObj.cmdText}}   </p>
                                </div>
                              </div>

                              <div class="px-1 float-sm-right name-tag position-relative py-2" *ngIf="cmtObj.userName==loginUsrName">
                                <div class="border px-3 py-2 mx-1 bg-chat-user rounded-top-left-medium rounded-bottom-right-medium rounded-bottom-left-medium">
                                  <small class="d-block text-secondary">
                                    {{cmtObj.userName}} {{cmtObj.cmtDate | date:'dd/MM/yyyy hh:mm a'}}
                                    <i (click)="delAtdComment(cmtObj.cmdId)" class="ti pointer ti-trash fa-lg mx-1 text-danger"></i> |
                                    <i *ngIf="cmtObj.chatType==0" title="Everyone" class="ti ti-unlock fa-lg mx-1"></i>
                                    <i *ngIf="cmtObj.chatType==1" title="Self" class="la la-file icon-rotate-180 text-primary fa-lg mx-1"></i>
                                    <i *ngIf="cmtObj.chatType==2" title="Private" class="ti ti-lock text-success fa-lg mx-1"></i>
                                  </small>
                                  <p class="d-inline-flex m-0"> {{cmtObj.cmdText}} <i *ngIf="(cmtObj.cmdText.includes('File:'))" (click)="downloadCommentFile()" class="la la-download pointer fa-lg m-1"></i> </p>

                                </div>
                              </div>

                            </div>
                            <div class="clearfix py-4"></div>
                            <div class="modal-footer modal-footer-fixed p-0 mt-2 border-0 chat-bottom">
                              <div class="bg-light-gray my-2 p-2 custom-tab w-100">
                                <div class="row">
                                  <div class="col-md-10 col-8 p-0 form-group my-0 px-2 mt-half hide-shadows">
                                    <textarea [(ngModel)]="commentText" class="form-control bg-light-gray mt-1" placeholder="Type your comment…" id="comments" rows="1"></textarea>
                                  </div>
                                  <div class="col-md-2 col-4 pt-2">
                                    <ul class="list-inline hide-arrow-drop mb-0 d-flex justify-content-center chat-icon-res pt-half-10">
                                      <li class="list-inline-item nav-item m-0" ngbDropdown>
                                        <a class="nav-link p-0" id="dropdownBasic1" [title]="commentType" ngbDropdownToggle><i [ngClass]="commentTypeClass"></i> </a>
                                        <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                          <li><a ngbDropdownItem>Send to</a></li>
                                          <li><a ngbDropdownItem (click)="commentType='Everyone';commentTypeClass='ti ti-unlock fa-lg mx-1';"><i class="ti ti-unlock"></i> Everyone</a></li>
                                          <li><a (click)="commentType='Private';openPrivateModal(templatePrivate);" ngbDropdownItem><i class="ti ti-lock text-success"></i> Private</a></li>
                                          <li><a ngbDropdownItem (click)="commentType='Self';commentTypeClass='la la-file icon-rotate-180 text-primary fa-lg mx-1';"><i class="la la-file icon-rotate-180 text-primary"></i> Self</a></li>
                                        </ul>
                                      </li>
                                      <li class="list-inline-item nav-item m-0">
                                        <div class="upload-btn-wrapper pointer">
                                          <i class="la la-paperclip fa-lg"></i>
                                          <input type="file" id="commentFile" #commentFile class="file-upload pointer" name="myfile" (change)="commentFileInput($event.target.files)" />
                                        </div>
                                      </li>
                                      <li class="list-inline-item nav-item m-0"><span class="bg-success rounded-circle mx-1 send-icon pointer" (click)="AddComment()"><i class="la la-paper-plane text-white fa-lg"></i></span></li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'active show':momTab3}" id="files-tab" role="tabpanel" aria-labelledby="files-tab">
          <div class="row">
            <div class="col-md-12 px-3">
              <div class="accordion accordion-menu" id="accordionfile">
                <div class="card">
                  <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                      <a class="btn btn-link text-secondary" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        Files
                      </a>
                    </h5>
                  </div>

                  <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionfile">
                    <div class="card-body pt-0 pb-6">
                      <div class="row">
                        <div class="col-md-6 px-2 pb-70 order-first">
                          <div class="form-group">
                            <div class="col-md-12 pt-3 px-0">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" id="allMeeting" type="radio" value="0" name="meeting" checked (change)="changeFileFilter(0);isFileUpload=true;">
                                <label class="form-check-label" for="allMeeting">All</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" id="meeting" type="radio" value="1" name="meeting" (change)="changeFileFilter(1);isFileUpload=true;">
                                <label class="form-check-label" for="meeting">Meeting Discussions</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" id="actionPoint" type="radio" value="2" name="meeting" (change)="changeFileFilter(2);isFileUpload=false;">
                                <label class="form-check-label" for="actionPoint">Actions Points</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" id="message" type="radio" value="3" name="meeting" (change)="changeFileFilter(3);isFileUpload=false;">
                                <label class="form-check-label" for="message">Chat</label>
                              </div>
                            </div>
                          </div>
                          <div class="border rounded bg-white py-2 text-center text-muted mt-3" *ngIf="fileList.length ===0 ||fileList==null ">
                            <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
                            <h5 class="py-4 text-center">No Data Available</h5>
                          </div>
                          <div class="p-3 border rounded-bottom rounded-right bg-light my-3" *ngFor="let objFile of fileList">
                            <span class="text-secondary f-bold-dubai pr-2">{{objFile.createByName}}</span> <small class="text-muted">{{objFile.createDate | date:'dd/MM/yyyy h:mm a '}}</small>
                            <div class="attachement-card rounded p-2 mt-2">
                              <i class="la fa-lg " [ngClass]="checkFileType(objFile.fileName)"></i> {{objFile.fileName}}
                              <div class="card-controls float-right text-secondary pt-1">
                                <ul class="list-inline list-badge hide-arrow-drop">

                                  <li class="list-inline-item nav-item" ngbDropdown>
                                    <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                                    <ul ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                      <li><a ngbDropdownItem (click)="DownloadFiles(objFile)"><i class="fa fa-download"></i> Download</a></li>
                                      <li><a ngbDropdownItem (click)="onDeleteFiles(objFile)"><i class="fa fa-trash"></i> Delete</a></li>
                                      <li><a ngbDropdownItem (click)="openFileRename(fileRenameTemplate,objFile)"><i class="fa fa-edit"></i> Rename</a></li>
                                    </ul>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>


                        </div>
                        <div class="col-md-6 pt-3 pt-md-2 mt-md-5" *ngIf="isFileUpload">
                          <div class="center">
                            <form #demoForm="ngForm" class="position-relative">
                              <button type="button" *ngIf="uploadedFiles.length >0 " class="position-absolute position-bottom-55 position-right-15 position-zindex1 btn btn-success btn-sm f-bold-dubai px-2 mb-2" (click)="uploadAttachedFiles('0','Meeting')">
                                Upload File ({{uploadedFiles.length}})
                              </button>
                              <file-upload [(ngModel)]="uploadedFiles" class="pointer" name="files"></file-upload>
                              <small>Maximum limit is 10 files, Max file size is 20MB<br />Supported file format :<span class="text-warning rounded px-2 p-0 m-0"> .jpeg, .jpg, .png, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .mp4, .pdf</span></small>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #templatePublish>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Publish MOM</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPub.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="!model.workFlowCondition1">
      This Minutes of Meeting will be published and sent to all attendees. No
      changes can be made in the document once you submit.<br /><br />
      Note: Your digital signature may be added to the attached documents as well
    </p>
    <p *ngIf="model.workFlowCondition1">
      You have not set a workflow for this Minutes of Meeting.<br />
      Would you like to Publish with you as the Reviewer and Approver?<br /><br />
      Note: Your digital signature may be added to the attached documents as well.
    </p>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary border-0" (click)="modalPub.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="updateMeetingStatus('MPUBLISH')">Publish <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
  </div>
</ng-template>
<ng-template #templateReview>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Send For Review</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalReview.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      This Minutes of Meeting will be sent to the following user(s) for Review:
    </p>
    <div class="content-list-overflow">
      <div *ngFor="let item of reviewerList; let i = index">
        <div id="{{item.attendeesUnoAtd
                                }}" class="d-none card mb-0 bg-white p-3 border profiledetails">
          <span class="position-absolute position-right-10 close-card pointer" (click)="closeCard(item.attendeesUnoAtd)"><i class="la la-close"></i></span>
          <div class="row profile-scroll">
            <div class="col-md-3 pr-0">
              <span><img class="img-fluid rounded-circle wh-80" [src]="item.picture" alt="Profile" /></span>
            </div>
            <div class="col-md-9">
              <div class="border-bottom">
                <h5 class="mb-0">{{item.nameAtd}}</h5>
                <p class="py-0 my-0 text-secondary">
                  {{item.designation}}<br>
                  <small><i class="la la-id-badge"></i>   {{item.prNumberAtd}}</small>
                </p>
              </div>
              <h5 class="pt-2 mb-0">Contact information</h5>
              <div class="row text-secondary">
                <div class="col-md-4"><i class="la la-envelope"></i> Email</div>
                <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
              </div>
              <div class="row text-secondary">
                <div class="col-md-4"><i class="la la-comments"></i> Chat</div>
                <div class="col-md-8"><a href="{{'mailto:'+item.emailAtd}}">{{item.emailAtd}}</a></div>
              </div>
              <div class="row text-secondary">
                <div class="col-md-4"><i class="la la-phone-square"></i>Phone</div>
                <div class="col-md-8">{{item.contactAtd==0?'-':item.contactAtd}}</div>
              </div>
            </div>
          </div>
        </div>
        <p>
          <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-1 text-brown f-bold-dubai mx-2 border pointer text-center" (click)="profileCard(item.attendeesUnoAtd)">{{getShortName(item.nameAtd)}} </span> <b>{{item.nameAtd}}</b>
        </p>
      </div>
    </div>


  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary border-0" (click)="modalReview.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="updateMeetingStatus('MSENDREVIEW')">Send For Review <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
  </div>
</ng-template>


<ng-template #templateUserDetail>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Reason</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalReson.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      {{resonText}}
    </p>

  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn text-secondary bg-white border-0" (click)="modalReson.hide()">Cancel</button>
  </div>
</ng-template>

<ng-template #templateApprove>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Approve</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalApprove.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Please confirm to approve the meeting and send for publish.<br />


    </p>

  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary border-0" (click)="modalApprove.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="updateMeetingStatus('MAPPROVE')">Approve <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
  </div>
</ng-template>

<ng-template #templateRev>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Review</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRev.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Please confirm that you have reviewed and send for approval.<br />
      <!--Please confirm to review the meeting and send for approval.-->

    </p>

  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary border-0" (click)="modalRev.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="updateMeetingStatus('MREVIEW')">Review <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
  </div>
</ng-template>

<ng-template #templateApproval>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Send for Approval</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalApproval.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      This Minutes of Meeting will be sent to the following user for Approval:
    </p>
    <div class="content-list-overflow">
      <div class="text text-dark" *ngIf="approver!=null">
        <div id="{{approver.attendeesUnoAtd}}" class="d-none card mb-0 bg-white p-3 border profiledetails">
          <span class="position-absolute position-right-10 close-card pointer" (click)="closeCard(approver.attendeesUnoAtd)"><i class="la la-close"></i></span>
          <div class="row profile-scroll">
            <div class="col-md-3 pr-0">
              <span><img class="img-fluid rounded-circle wh-80" [src]="approver.picture" alt="Profile" /></span>
            </div>
            <div class="col-md-9">
              <div class="border-bottom">
                <h5 class="mb-0">{{approver.nameAtd}}</h5>
                <p class="py-0 my-0 text-secondary">
                  {{approver.designation}}<br>
                  <small><i class="la la-id-badge"></i>   {{approver.prNumberAtd}}</small>
                </p>
              </div>
              <h5 class="pt-2 mb-0">Contact information</h5>
              <div class="row text-secondary">
                <div class="col-md-4"><i class="la la-envelope"></i> Email</div>
                <div class="col-md-8"><a href="{{'mailto:'+approver.emailAtd}}">{{approver.emailAtd}}</a></div>
              </div>
              <div class="row text-secondary">
                <div class="col-md-4"><i class="la la-comments"></i> Chat</div>
                <div class="col-md-8"><a href="{{'mailto:'+approver.emailAtd}}">{{approver.emailAtd}}</a></div>
              </div>
              <div class="row text-secondary">
                <div class="col-md-4"><i class="la la-phone-square"></i>Phone</div>
                <div class="col-md-8">{{approver.contactAtd==0?'-':approver.contactAtd}}</div>
              </div>
            </div>
          </div>
        </div>
        <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-1 text-brown f-bold-dubai mx-2 border pointer text-center" (click)="profileCard(approver.attendeesUnoAtd)">{{getShortName(approver.nameAtd)}}</span>  <b>{{approver.nameAtd}}</b>
      </div>
    </div>

  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary border-0" (click)="modalApproval.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="updateMeetingStatus('MSENDAPPROVE')">Send for Approval <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1 position-relative position-top-minus-5"></span></button>
  </div>
</ng-template>
<!--modal private message start-->
<ng-template #templatePrivate>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Private Message</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPrivate.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>Add the users you wish to send this message to</p>
    <div class="custom-tab">
      <div class="input-group form-group">
        <div class="input-group-prepend">
          <span class="input-group-text border-0 bg-light-gray " id="basic-addon1"><i class="la la-search icon-rotate-90 fa-lg"></i></span>
        </div>
        <input type="text" class="form-control" placeholder="Search" (keyup)="searchGrid()" [(ngModel)]="searchText" aria-label="Username" aria-describedby="basic-addon1">
      </div>
    </div>
    <div>Members in this meeting</div>
    <ul class="list-group my-3">
      <li class="list-group-item d-flex align-items-center border-top-0 border-left-0 border-right-0 border-bottom mb-0 px-0" *ngFor="let item of commentAttendeeList">
        <div>
          <span class="bg-light rounded-circlebg-light rounded-circle circle-40 py-2 px-2 text-brown f-bold-dubai mx-2 border">{{getShortName(item.name)}}</span> {{item.name}}
          <label class="checkbox-btn">
            <input type="checkbox" [(ngModel)]="item.check">
            <span class="checkmark"></span>
          </label>
        </div>
      </li>
    </ul>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary border-0" (click)="modalPrivate.hide()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="modalPrivate.hide();commentTypeClass='ti ti-lock text-success fa-lg mx-1';">Apply</button>
  </div>
</ng-template>


<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">File Attachment</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="modalPub.hide()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12 px-2 pb-70">
        <div class="border rounded bg-white py-4 text-center text-muted h-100 mb-3" *ngIf="actionFileList.length ===0||actionFileList==null">
          <!--<img src="{{noDataImage}}" class="img-fluid" alt="No Data" />-->
          <h5>No Data Available</h5>
        </div>

        <div class="p-3 border rounded-bottom rounded-right bg-light my-3" *ngFor="let objFile of actionFileList">
          <span class="text-secondary f-bold-dubai pr-2">{{objFile.createByName}}</span> <small class="text-muted">{{objFile.createDate | date:'dd/MM/yyyy h:mm a '}}</small>
          <div class="attachement-card rounded p-2 mt-2">
            <i class="la fa-lg " [ngClass]="checkFileType(objFile.fileName)"></i> {{objFile.fileName}}
            <div class="card-controls float-right text-secondary pt-1">
              <ul class="list-inline list-badge hide-arrow-drop">

                <li class="list-inline-item nav-item" ngbDropdown>
                  <a class="nav-link p-0" id="dropdownBasic1" ngbDropdownToggle><i class="la la-ellipsis-v fa-lg"></i></a>
                  <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="attached-symbol">
                    <li><a ngbDropdownItem (click)="DownloadFiles(objFile)"><i class="fa fa-download"></i> Download</a></li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer border-0">
    <button type="button" class="btn btn-outline-secondary" (click)="modalPub.hide()">Close</button>

  </div>
</ng-template>


<ng-template #templateReason>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Attendee - {{atdReasonModel.status}}</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="closeAttendeeReason()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form name="ar" id="ar" #ar="ngForm" (ngSubmit)="submitAttendeeReason(ar)" novalidate>
      <div class="row py-2 custom-tab">

        <div class="col-md-12" *ngIf="atdReasonModel.status == 'On Behalf'">
          <div class="form-group">
            <ng-select [items]="UserList" class="form-control p-0"
                       bindLabel="fullAttendeeName"
                       bindValue="fullAttendeeName"
                       required #SelectedReason="ngModel"
                       [(ngModel)]="atdReasonModel.apologizedReason"
                       id="SelectedReason"
                       name="SelectedReason"
                       [ngClass]="{ 'error':isSubmitReason  && SelectedReason.invalid }"
                       [multiple]="false"
                       [searchable]="true"
                       [virtualScroll]="true"
                       [minTermLength]="3"
                       placeholder="Search by name ">
              <ng-template ng-option-tmp let-item="item">
                <div class="line">{{item.fullAttendeeName}}</div>
                <div class="line-designation">{{item.designation}} {{item.division}}</div>
              </ng-template>
            </ng-select>
            <div *ngIf="isSubmitReason && SelectedReason.invalid">
              <div class="text-danger"> Select the user</div>
            </div>
          </div>
        </div>

        <div class="col-md-12" *ngIf="atdReasonModel.status == 'Apologized'">



          <div class="form-group">
            <textarea class="form-control" rows="3"
                      required #SelectedReason="ngModel"
                      [(ngModel)]="atdReasonModel.apologizedReason"
                      id="SelectedReason"
                      name="SelectedReason"
                      [ngClass]="{ 'error':isSubmitReason  && SelectedReason.invalid }"
                      placeholder="Apologize Reason ">
            </textarea>
            <div *ngIf="isSubmitReason && SelectedReason.invalid">
              <div class="text-danger"> Enter the Apologize Reason</div>
            </div>
          </div>
        </div>
        <div class="modal-footer w-100 border-0">
          <button type="button" class="btn btn-outline-secondary border-0 px-4" (click)="closeAttendeeReason()">Cancel</button>
          <button class="btn btn-success px-4">Save</button>
        </div>
      </div>
    </form>
  </div>
  
</ng-template>

<ng-template #templateActionPoint>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">{{enableAP ==false?'Meeting Discussions':subPoint == ''?'Action Points':'Sub-Point'}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeActionPoint()">
      <span aria-hidden="true"><i class="la la-close"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <form name="actionForm" id="actionForm" #actionForm="ngForm" (ngSubmit)="submitEditActionPoint(actionForm)" novalidate>
      <div class="row py-2 custom-tab">
        <div class="col-md-12">
          <div class="form-group mb-3 position-relative">
            <label for="note" class="required">{{enableAP ==false?'Meeting Discussions':subPoint == ''?'Action Points':'Sub-Point'}} <span class="text-danger">*</span></label>

            <quill-editor theme="snow" id="note" required #note="ngModel" class="custom-form-control" row="3" style="background-color:#f1f1f1"
                          name="note" [ngClass]="{ 'error':isSubmitReason  && note.invalid }" [(ngModel)]="apModel.note" [styles]="editorStyle" placeholder="Enter your text here">
            </quill-editor>
            <div *ngIf="isSubmitReason && note.invalid">
              <div class="text-danger"> Enter the {{enableAP?'Action Point':'Meeting Discussion'}}</div>
            </div>
          </div>
        </div>

        <div class="col-md-6 pt-3" *ngIf="enableAP">
          <div class="form-group">
            <label for="dueDate">Due Date</label>
            <input type="date" onkeydown="return false" class="form-control col-md-12" id="dueDate" #dueDate="ngModel"
                   name="dueDate" [(ngModel)]="apModel.dueDate" placeholder="Set Date">
          </div>
        </div>
        <div class="col-md-6 pt-3" *ngIf="enableAP">
          <div class="form-group">
            <label for="priority">Priority</label>

            <select class="custom-select form-control col-md-12" placeholder="Set Priority" [(ngModel)]="apModel.priority" #priority="ngModel" id="priority" name="priority">
              <option value="Low Priority">Low Priority </option>
              <option value="Medium Priority">Medium Priority</option>
              <option value="High Priority">High Priority</option>
            </select>
          </div>
        </div>

        <div class="col-md-12" *ngIf="enableAP">
          <div class="form-group">
            <label for="responsibility">Responsibility</label>
            <ng-select [items]="attendeeDDList" class="form-control col-md-12 p-0"
                       bindLabel="nameAtd"
                       bindValue="attendeesUnoAtd"
                       #responsibility="ngModel"
                       [(ngModel)]="apModel.responsibility"
                       id="responsibility"
                       name="responsibility"
                       [multiple]="true"
                       [searchable]="true"
                       [virtualScroll]="true"
                       [minTermLength]="3"
                       placeholder="Assign Responsibility">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 w-100">
        <button class="btn btn-success px-4">Save</button>
        <button type="button" class="btn btn-outline-secondary border-0 px-4" (click)="closeActionPoint()">Cancel</button>
      </div>
    </form>
  </div>

</ng-template>
<!--modal private message start-->


<ng-template #templateAdd>
  <bs-modal-backdrop class="modal-backdrop fade in show" style="z-index:-1;" id="overlayDiv" *ngIf="isModalShow"></bs-modal-backdrop>
  <div class="modal-header pb-0 border-0">
    <div class="custom-tab d-block w-100">
      <h4 class="modal-title text-left px-2 f-bold-dubai pb-3">{{modalText}}</h4>
      <!--<small class="px-2"><a class="text-secondary" (click)="modalRef.hide();"><i class="ti ti-arrow-left"></i> Back to Meeting Minutes</a></small>-->
      <button type="button" class="close close-abs text-right" id="addclose" name="addclose" #addclose aria-label="Close" (click)="modalAdd.hide();isModalShow=false;">
        <span aria-hidden="true"><i class="la la-close"></i></span>
      </button>

    </div>
  </div>
  <app-add-meeting pagetype="MEETING" [meetingEditUno]="meetingEditUno" [inpUserList]="UserList"></app-add-meeting>

</ng-template>



<ng-template #fileRenameTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left f-bold-dubai">Rename File</h4>

    <button type="button" class="close pull-right" aria-label="Close" (click)="fileRename.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <form name="file" (ngSubmit)="file.form.valid && renameFile()" #file="ngForm" novalidate>
    <div class="modal-body">

      <div class="form-group">
        <label for="exampleInputEmail1">File Name<span class="text-danger">*</span></label>
        <input type="text" class="form-control" name="fileName" [(ngModel)]="model1.fileName" placeholder="File Name" #fileName1="ngModel" [ngClass]="{ 'is-invalid': file.submitted && fileName1.invalid }" required >
        <div *ngIf="file.submitted && fileName1.invalid" class="invalid-feedback">
          <div *ngIf="fileName1.errors.required">File Name is required</div>
          
        </div>
      </div>
      

    </div>
    <div class="modal-footer border-0">
      <button type="button" class="btn btn-outline-secondary" (click)="fileRename.hide()">Cancel</button>
      <button class="btn btn-success">Submit</button>
    </div>
  </form>
</ng-template>

